import { useEffect, useState } from "react";
import url from "../ServerUrl";

const emptyForm = { driverid: "", firstname: "", lastname: "", email: "", contact: "", location: "", status: "Free" };

const ActionIcon = ({ type }) => (
    <span aria-hidden="true" className="driver-action-symbol">{type === "edit" ? "✎" : "⌫"}</span>
);

const Drivers = () => {
    const [drivers, setDrivers] = useState([]);
    const [editing, setEditing] = useState(null);
    const [message, setMessage] = useState("");

    const request = async (body) => {
        const response = await fetch(`${url}/resolveQuery`, {
            method: "POST",
            headers: { "Content-Type": "application/json", token: localStorage.token },
            body: JSON.stringify(body),
        });
        if (!response.ok) throw new Error("Request failed");
        return response.json();
    };

    const loadDrivers = async () => {
        try {
            const data = await request({ query: "getDrivers" });
            setDrivers(Array.isArray(data) ? data : []);
        } catch {
            setMessage("Unable to load drivers. Please refresh and try again.");
        }
    };

    useEffect(() => { loadDrivers(); }, []);

    const saveEdit = async (event) => {
        event.preventDefault();
        try {
            await request({ query: "updateDriver", ...editing });
            setEditing(null);
            setMessage("Driver updated successfully.");
            await loadDrivers();
        } catch {
            setMessage("Driver update failed. Check the entered values.");
        }
    };

    const deleteDriver = async (driver) => {
        if (!window.confirm(`Delete driver ${driver.firstname} ${driver.lastname}?`)) return;
        try {
            await request({ query: "deleteDriver", driverid: driver.driverid });
            setMessage("Driver deleted successfully.");
            await loadDrivers();
        } catch {
            setMessage("Driver deletion failed.");
        }
    };

    return (
        <div className="admin_ambulances drivers-page">
            <div className="drivers-heading">
                <div><h1>Drivers</h1><p className="drivers-count">Database drivers ({drivers.length})</p></div>
                <button className="drivers-refresh-button" onClick={loadDrivers} type="button">↻ Refresh</button>
            </div>
            {message && <p className="drivers-message" role="status">{message}</p>}
            <div className="ambulance_table drivers-table-wrap">
                <table className="history_table drivers-table">
                    <thead><tr className="history_table_header">
                        <th>ID</th><th>First Name</th><th>Last Name</th><th>Email</th><th>Contact No</th><th>Ambulance ID</th><th>Status</th><th>Edit</th><th>Delete</th>
                    </tr></thead>
                    <tbody>
                        {drivers.map((driver) => <tr key={driver.driverid}>
                            <td>{driver.driverid}</td><td>{driver.firstname}</td><td>{driver.lastname}</td><td>{driver.email}</td><td>{driver.contact}</td><td>{driver.ambulanceid || "—"}</td>
                            <td className={String(driver.status).toLowerCase() === "free" ? "fulfilled" : "canceled"}>{driver.status || "Free"}</td>
                            <td><button className="driver-action-button" title="Edit driver" aria-label={`Edit ${driver.firstname}`} onClick={() => setEditing({ ...emptyForm, ...driver })} type="button"><ActionIcon type="edit" /></button></td>
                            <td><button className="driver-action-button driver-delete-button" title="Delete driver" aria-label={`Delete ${driver.firstname}`} onClick={() => deleteDriver(driver)} type="button"><ActionIcon type="delete" /></button></td>
                        </tr>)}
                        {drivers.length === 0 && <tr><td className="drivers-empty" colSpan="9">No drivers found in the local database.</td></tr>}
                    </tbody>
                </table>
            </div>
            {editing && <div className="driver-edit-panel" role="dialog" aria-modal="true"><form onSubmit={saveEdit}>
                <div className="driver-edit-heading"><h2>Edit Driver</h2><button type="button" onClick={() => setEditing(null)} aria-label="Close">×</button></div>
                <div className="driver-form-grid">
                    {[["firstname", "First name"], ["lastname", "Last name"], ["email", "Email"], ["contact", "Contact"], ["location", "Location"]].map(([name, label]) => <label key={name}>{label}<input required value={editing[name] || ""} onChange={(event) => setEditing({ ...editing, [name]: event.target.value })} /></label>)}
                    <label>Status<select value={editing.status || "Free"} onChange={(event) => setEditing({ ...editing, status: event.target.value })}><option>Free</option><option>Busy</option></select></label>
                </div>
                <div className="driver-form-actions"><button type="button" onClick={() => setEditing(null)}>Cancel</button><button type="submit">Save changes</button></div>
            </form></div>}
        </div>
    );
};

export default Drivers;
